import actions from './actions';
import { createReducer } from '../../../../../helpers/reducer';

const initState = {
  referrals: null,
  referrer: null,
  loading: false,
};

function onLoad(state) {
  return {
    ...state,
    loading: true,
  };
}

function onLoadSuccess(state, { payload }) {
  const { data } = payload;
  const { referrer, referrals } = data;

  return {
    ...state,
    referrals,
    referrer,
    loading: false,
  };
}

function onClearStore() {
  return { ...initState };
}

export default createReducer(initState, {
  [actions.LOAD]: onLoad,
  [actions.LOAD_SUCCESS]: onLoadSuccess,
  [actions.CLEAR_STORE]: onClearStore,
});
